<template>
  <div class="container page" style="background-color: #f4f4f4;">
    <van-nav-bar :title="$t('misc.watch_video')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video" class="video-js"></video>
    </div>
    <a @click="back('recharge')" v-if="remain_watch_times==0" class="btn">
      <p>{{ $t('misc.remain_plays_zero') }}</p>
      <p>{{ $t('misc.get_vip_unlimited') }}</p>
      <div class="flex flex-item flex-content icon"><van-icon name="down" color="#EC6272" size="20"
          style="transform: rotate(-90deg);" /></div>
    </a>
    <div class="movie-descript">
      <p>{{ this.videoInfo.vod_name }}</p>
      <!-- <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span> -->
    </div>
    <div class="movie-content">
      <div class="movie-body">
        <div class="movie-title">
          {{ $t('misc.guess_you_like') }}
        </div>
      </div>
      <div class="videos">
        <div class="videoItem" v-for="item in moreVideoInfo" :key="item.id" @click="toPlayVideo(item)">
          <div class="img"><img :src="$baseURL + item.cover" class="img"></div>
          <div class="info">
            <h3>{{ item.title }}</h3>
            <p>{{ $t('misc.rating') }}{{ item.fraction }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      times: null,
      remain_watch_times:0
    };
  },
  methods: {
    back(type) {
      this.$router.go(-1);
      if (type == 'recharge') {
        setTimeout(() => {
          this.$dialog.alert({
            message: this.$t('misc.recharge_contact_service'),
            className: 'noVw'
          });
        }, 300);
      }
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        if (res.code == 400) {
          this.remain_watch_times=0
          this.$dialog.alert({
            message: res.msg,
            className: 'noVw'
          });
          this.player.dispose();
          this.player = null;
          return;
        }
        this.remain_watch_times=1
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.$baseURL+this.videoInfo.vod_pic;
        let videos = document.getElementById("my-video");

        videos.poster = this.cover;
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "?id=" + id });
        location.reload();
      }
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = res.data;
      });
    },
    getVideo() {
      // this.player = videojs("my-video",  {
      //   height:"200px",
      //   preload: "auto", // 预加载
      //   controls: true,  // 显示播放的控件
      //   multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      // });
      this.player.src([
        {
          src: this.nowPlayVideoUrl,
          type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
        },
      ]);
      this.player.poster(this.cover);

    },
    deductWatchCount() {
      this.$http({
        method: "get",
        url: "deductWatchCount",
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem();
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("video.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.player = videojs(
        "my-video",
        {
          height: "200px",
          preload: "auto", // 预加载
          controls: true, // 显示播放的控件
          multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
        },
        function () {
          this.on("play", () => {
            _this.is_play = true;
            _this.deductWatchCount()
          });
        }
      );

      this.getUserInfo();
      // this.times = setInterval(() => {
      //   if (this.is_play) {
      //     const ct = Math.round(this.player.currentTime());
      //     if (ct >= 30) {
      //       this.player.pause();
      //       this.$toast(this.$t("video.buy"));
      //       return;
      //     }
      //   }
      // }, 1000 * 2);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;
}

.movie-video {
  height: 400px;
}

.video-js {
  width: 100%;
  height: 400px;
  font-size: 24px;
}

.btn {
  background-image: -webkit-linear-gradient(45deg, rgba(235, 96, 112, 0.875), #EC6272);
  background-image: linear-gradient(45deg, rgba(235, 96, 112, 0.875), #EC6272);
  display: block;
  margin: 28px 60px;
  font-size: 24px;
  color: #fff;
  height: 80px;
  border-radius: 40px;
  text-align: center;
  line-height: 1;
  position: relative;

  p:nth-child(1) {
    font-size: 22.4px;
    font-weight: bold;
  }

  p {
    font-size: 24px;
    padding-top: 8px;
  }

  .icon {
    width: 66px;
    height: 66px;
    border-radius: 100%;
    background: #ffffff;
    position: absolute;
    right: 12px;
    top: 6px;
  }
}

.videos {
  padding: 16px 20px 0 16px;

  .videoItem {
    width: 100%;
    margin-top: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    padding-bottom: 8px;
    border-bottom: 2px solid #fff;
    overflow: hidden;

    .img {
      width: 184px;
      height: 168px;

      img {
        /* height: 100%; */
        /* width: 100%; */
        height: 168px;
      }
    }

    .info {
      padding-left: 16px;

      h3 {
        color: #000;
        font-size: 30px;
        font-weight: 700;
        width: 560px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      p {
        color: #000;
        font-size: 28px;
      }
    }
  }
}

.movie-content {
  flex: 1;
  overflow-y: auto;
}

.movie-descript {
  width: 100%;
  /* height: 140px; */
  /* background-color: #fff; */
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}

.movie-descript p {
  font-size: 30px;
  font-weight: 700;
  color: #000;
}

.movie-descript span {
  color: rgb(170, 45, 220);
  font-size: 0.8rem;
  background: rgb(242, 242, 245);
  padding: 10px;
  border-radius: 16px;
}

.movie-content .movie-body {
  margin: 0 auto;
}

::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}

.movie-content .movie-body .movie-title {
  box-sizing: border-box;
  /* 改成 inline-block：盒子宽度跟着文字走，缎带自动包住整段文案（原来缎带背景写死 162px，
     英文文案比它长，超出部分的白字落在浅色背景上就"看不见"了） */
  display: inline-block;
  vertical-align: top;
  height: 58px;
  line-height: 50px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  white-space: nowrap;
  /* 文字左侧 30px（+ 16px border）让开缎带尖角，右侧 8px（+ 12px border） */
  padding: 0 8px 0 30px;
  /* 缎带改用九宫格 border-image：左端尖角尾巴(源图 16px)和右端 V 形缺口(源图 12px)保持原形，
     只有中间纯色区随文字横向拉伸 —— 文案再长也不会被裁掉，两端装饰也不会被拉变形。
     这里用 longhand：fill 必须属于 border-image-slice（写在斜杠前），
     简写里把 fill 放在 /width 之后是非法语法，浏览器会整条丢弃，只剩兜底底色变成纯长方形 */
  /* 兜底底色（border-image 万一不生效时不至于白字白底）：只铺在主条高度 48px 内，
     background-origin 默认 padding-box，正好只覆盖左右两端装饰之间的中间拉伸区，
     不会侵入缺口/尾巴，也不会从下方透出来把缎带撑高 */
  background-image: linear-gradient(#ff4d67, #ff4d67);
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% 48px;
  border-style: solid;
  border-color: transparent;
  border-width: 0 12px 0 16px;
  border-image-source: url(/img/video-title-ribbon.png);
  border-image-slice: 0 12 0 16 fill;
  border-image-width: 0 12px 0 16px;
  border-image-repeat: stretch;
}

.movie-content .movie-body .movie-title>div:first-child {
  width: 410px;
}

.movie-content .movie-body .movie-title>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}

.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}

.hotlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.hotlist div {
  position: relative;
  width: calc(50% - 10px);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 20px;
}

.hotlist div img {
  width: 100%;
  height: 27vw;
}

.hotlist div div {
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, .4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 3vw;
  height: 8vw;
  border-radius: 16px;
}

.hotlist div div span {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding-left: 20px;
}
</style>
